import { AUXLINE_MARGIN, DRAW_GRID, enumChartTypes, GROUPBOX_MARGIN } from "../constants";
import { QPageAuxLine } from "./QPageAuxLine";
import { QPolySet } from "./QPolySet";
import { QBoxGroupList } from "./QBoxGroupList";
import { QTileArray } from "./QTileArray.js";

export class QLayoutExtras {
  constructor() {
    this.fPolySets = null;
  }

  InitExtras() {
    if (!this.fPolySets) {
      this.fPolySets = [];
    }
    this.fPolySets.length = 0;

    if (!this.fBoxGroupListObj) {
      this.fBoxGroupListObj = new QBoxGroupList();
    }

    this.fBoxGroupListObj.length = 0;
  }

  GenerateBoxGroups(nodeEntity) {
    if (!nodeEntity) {
      return;
    }

    this.InitExtras();

    var layout = nodeEntity.GetNodeLayout();
    if (layout === null) return;

    var origin = { x: layout.GetPositionX(), y: layout.GetPositionY() };
    this.generatePolySets(nodeEntity, origin);
    this.MergePolySets();
    this.UpdateGroupList(layout);
  }

  generatePolySets(nodeEntity, origin) {
    if (!nodeEntity) {
      return;
    }

    var groupIDs = {};
    if (nodeEntity.fNode) groupIDs = nodeEntity.fNode.GetBoxHighlightGroups();

    var children = nodeEntity.GetChildren();
    for (var i = 0; i < children.length; i++) {
      var childEntity = children[i];
      this.generatePolySets(childEntity, origin);
    }

    var boxLayout = nodeEntity.fNode ? nodeEntity.fNode.GetLayout() : null;
    if (boxLayout === null) return;

    var boxLeft = boxLayout.GetPositionX() - origin.x;
    var boxTop = boxLayout.GetPositionY() - origin.y;
    var box = {
      left: boxLeft - GROUPBOX_MARGIN,
      right: boxLeft + boxLayout.GetBoxWidth() + GROUPBOX_MARGIN,
      top: boxTop - GROUPBOX_MARGIN,
      bottom: boxTop + boxLayout.GetBoxHeight(false) + GROUPBOX_MARGIN
    };

    // update the existing box groups
    for (i in this.fPolySets) {
      var polySet = this.fPolySets[i];
      var existingGroupID = polySet.GetID();
      var isExisting = groupIDs[existingGroupID];
      if (isExisting) {
        polySet.AddPolyFromBox(box);
        delete groupIDs[existingGroupID];
      }
    }

    // if any groupIDs are left, these are first instance of such ID
    for (var aGroup in groupIDs) {
      var newPolySet = new QPolySet();
      newPolySet.AddPolyFromBox(box);
      newPolySet.SetID(aGroup);
      //var testColor = this.GetColorByID(groupIDs[i]);
      var theColor = groupIDs[aGroup];
      newPolySet.SetColor(theColor);
      this.fPolySets.push(newPolySet);
    }
  }

  GetColorByID(id) {
    // Temp code to assign different colors to different PolySets
    var colorSets = [];
    colorSets.push([10, 120, 42, 0.3]);
    colorSets.push([120, 50, 52, 0.3]);
    colorSets.push([67, 50, 231, 0.3]);
    colorSets.push([100, 100, 100, 0.3]);

    var ix = id % colorSets.length;

    return colorSets[ix];
  }

  MergePolySets() {
    // This is where combining and merging of all polysets happening

    for (var i = 0; i < this.fPolySets.length; i++) {
      this.fPolySets[i].MergePolys();
    }
  }

  UpdateGroupList(layout) {
    this.fBoxGroupListObj.InitBoxGroupList();
    var nPolySets = this.fPolySets.length;
    for (var i = 0; i < nPolySets; i++) {
      var polySet = this.fPolySets[i];
      this.fBoxGroupListObj.AddPolySet(layout, polySet);
    }
  }

  GetBoxGroupListObj() {
    return this.fBoxGroupListObj;
  }

  //----------------------------------
  GetAllNodes(aNode, nodeList) {
    var numChildren = aNode.GetNumChildren();
    for (var i = 0; i < numChildren; i++) {
      var child = aNode.GetIndexChild(i);
      if (child != null) this.GetAllNodes(child, nodeList);
    }

    nodeList.push(aNode);
  }

  GenerateAuxAssociations(nodeEntity, pageAuxLines) {
    if (pageAuxLines === null || nodeEntity.fNode === null) {
      return;
    }

    // If the root node is not from main subchart, do not touch auxlines.
    var aNode = nodeEntity.fNode;
    if (!aNode.IsInMainSubChart()) {
      return;
    }

    pageAuxLines.length = 0;

    var nodeList = [];
    this.GetAllNodes(aNode, nodeList);
    for (var i = 0; i < nodeList.length; i++) {
      aNode = nodeList[i];
      aNode.SetupDottedID(nodeList);
    }

    var auxLineID = 0;
    for (i = 0; i < nodeList.length; i++) {
      aNode = nodeList[i];
      var numDotted = aNode.NumDotted();
      for (var j = 0; j < numDotted; j++) {
        var otherNode = aNode.GetIndexDottedRef(j);
        if (otherNode !== null) {
          var auxLine = new QPageAuxLine();
          auxLine.SetID(auxLineID++);
          var nodeEntity1 = aNode.GetNodeEntity();
          var nodeEntity2 = otherNode.GetNodeEntity();
          auxLine.SetNodeEntity(nodeEntity1);
          auxLine.SetNodeEntity(nodeEntity2);
          nodeEntity1.SetAuxlineFlag(true);
          nodeEntity2.SetAuxlineFlag(true);
          pageAuxLines.push(auxLine);
        }
      }
    }
  }

  GenerateConnectedLine(nodeEntity, pageAuxLines, chartType) {
    if (pageAuxLines === null || nodeEntity.fNode === null) return;

    var invertedChart = chartType === enumChartTypes.inverted;

    if (DRAW_GRID || pageAuxLines.length > 0) {
      var tileArray = this.GenerateGrid(nodeEntity);
    }
    // now make it drawn on screen by riding on auxLines
    var layout = nodeEntity.fNode.GetLayout();

    var ctrlPoints = [];
    if (DRAW_GRID) {
      var style = { strokeStyle: "#777777", dashStyle: false, lineWidth: 1 };
      var style2 = { strokeStyle: "#CC1111", dashStyle: false, lineWidth: 1 };

      var lines = tileArray.GetConnectionLines();

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        ctrlPoints.length = 0;
        var y1Adjusted = AdjustForInvertedChart(line.pt1.y);
        var y2Adjusted = AdjustForInvertedChart(line.pt2.y);
        ctrlPoints.push({ x: line.pt1.x, y: y1Adjusted });
        ctrlPoints.push({ x: line.pt2.x, y: y2Adjusted });
        var auxLine = new QPageAuxLine();
        auxLine.UpdateLine(layout, style, ctrlPoints);

        pageAuxLines.push(auxLine);
        ctrlPoints.length = 0;
        ctrlPoints.push({ x: line.pt1.x - 1, y: y1Adjusted - 1 });
        ctrlPoints.push({ x: line.pt1.x - 1, y: y1Adjusted + 1 });
        ctrlPoints.push({ x: line.pt1.x + 1, y: y1Adjusted + 1 });
        ctrlPoints.push({ x: line.pt1.x + 1, y: y1Adjusted - 1 });
        ctrlPoints.push({ x: line.pt1.x - 1, y: y1Adjusted - 1 });
        auxLine = new QPageAuxLine();
        auxLine.UpdateLine(layout, style2, ctrlPoints);
        pageAuxLines.push(auxLine);

        ctrlPoints.length = 0;
        ctrlPoints.push({ x: line.pt2.x - 1, y: y2Adjusted - 1 });
        ctrlPoints.push({ x: line.pt2.x - 1, y: y2Adjusted + 1 });
        ctrlPoints.push({ x: line.pt2.x + 1, y: y2Adjusted + 1 });
        ctrlPoints.push({ x: line.pt2.x + 1, y: y2Adjusted - 1 });
        ctrlPoints.push({ x: line.pt2.x - 1, y: y2Adjusted - 1 });
        auxLine = new QPageAuxLine();
        auxLine.UpdateLine(layout, style2, ctrlPoints);
        pageAuxLines.push(auxLine);
      }
    }

    if (pageAuxLines.length === 0) return;

    // now go through auxlines to see which ones are from chart boxes
    var entities = [];
    for (i = 0; i < pageAuxLines.length; i++) {
      auxLine = pageAuxLines[i];
      var entityPair = auxLine.GetNodeEntities();
      if (entityPair.source !== null && entityPair.target !== null) {
        entities.push(entityPair);
      }
    }

    for (i = 0; i < entities.length; i++) {
      entityPair = entities[i];

      var sourceAnchors = entityPair.source.GetAuxlineAnchors();
      var targetAnchors = entityPair.target.GetAuxlineAnchors();

      var bestPath = null;
      var bestScore = Number.POSITIVE_INFINITY;

      for (var is = 0; is < sourceAnchors.length; is++) {
        for (var it = 0; it < targetAnchors.length; it++) {
          var sourcePoint = sourceAnchors[is];
          var targetPoint = targetAnchors[it];

          tileArray.ResetStatuses();
          var path = tileArray.FindShortestPath(sourcePoint, targetPoint);
          var score = this.PathScore(path, sourcePoint, targetPoint);
          if (score < bestScore) {
            bestPath = path.slice(0);
            bestScore = score;
          }
        }
      }

      style = { strokeStyle: "#CC3333", dashStyle: true, lineWidth: 1 };

      if (bestPath) {
        ctrlPoints.length = 0;
        for (var j = 0; j < bestPath.length; j++) {
          // if chart is inverted, a correction needs to happen. The following correction produces
          // right result.
          var updatedPoint = {
            x: bestPath[j].x,
            y: AdjustForInvertedChart(bestPath[j].y)
          };
          ctrlPoints.push(updatedPoint);
        }
        auxLine = new QPageAuxLine();
        auxLine.UpdateLine(layout, style, ctrlPoints);
        pageAuxLines.push(auxLine);
      }
    }

    function AdjustForInvertedChart(y) {
      var yInverted = invertedChart
        ? nodeEntity.fBox.fHeight - 2 * nodeEntity.fBox.fBorderThickness - y
        : y;
      return yInverted;
    }
  }

  PathScore(path, sourcePt, targetPt) {
    var score = Number.POSITIVE_INFINITY;

    if (path.length > 1) {
      score = 100 * path.length;

      for (var i = 0; i < path.length - 1; i++) {
        var pt1 = path[i];
        var pt2 = path[i + 1];

        score += Math.sqrt(Math.pow(pt1.x - pt2.x, 2) + Math.pow(pt1.y - pt2.y, 2));
      }
    }

    score *= sourcePt.scorefactor * targetPt.scorefactor;

    return score;
  }

  GenerateGrid(nodeEntity) {
    var tileArray = new QTileArray();

    var boxMargin = 0;
    var boxes = nodeEntity.GetBoxes(boxMargin);
    tileArray.ConstructByBoxes(boxes, AUXLINE_MARGIN);

    return tileArray;
  }

  UpdateDottedLines(rootNode, pageAuxLines) {
    if (pageAuxLines === null || pageAuxLines.length === 0) {
      return;
    }

    var layout = rootNode.GetLayout();
    var nLines = pageAuxLines.length;
    for (var i = 0; i < nLines; i++) {
      var auxLine = pageAuxLines[i];

      auxLine.UpdateLine(layout);
    }
  }
}
